import { Box, Grid, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { apiClient, ADMIN_SERVER_BASE_URL } from "../util/apiClient";
import {
  addModeleRapport,
  IModeleRapport,
  updateModeleRapport,
} from "../store/modeleRapportSlice";
import { IReduxState } from "../store";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import { errorNotify, successNotify } from "../util/functions";

export interface IAddModeleProps {
  renderModeleEditable: boolean;
  objetModele: IModeleRapport;
  libelleModeleRapport: string;
  setLibelleModeleRapport: any;
  setRenderModeleEditable: any;
  typeRapport: any;
  setTypeRapport: any;
}

export default function AddModele(props: IAddModeleProps) {
  //props
  const {
    renderModeleEditable,
    objetModele,
    libelleModeleRapport,
    setLibelleModeleRapport,
    setRenderModeleEditable,
    typeRapport,
    setTypeRapport
  } = props;

  //redux
  const dispatch = useDispatch();
  const { modelesRapport } = useSelector(
    (state: IReduxState) => state.modeleRapport
  );

  //hooks
  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    try {
      setLoading(true);
      const apiPayload = {
        libelleModeleRapport,
        idTypeRapport: typeRapport.idTypeRapport
      };
      const res: any = await apiClient.post(
        ADMIN_SERVER_BASE_URL,
        "/tablesystem/ajoutermodelerapport",
        apiPayload
      );
      console.log("🚀 ~ handleSave ~ res:", res)

      if (res.status === 1) {

        // const parsedData = {
        //   ...res.data,
        //   planModeleRapport: JSON.parse(res.data.planModeleRapport),
        // };

        dispatch(addModeleRapport(res.data));
        console.log("🚀 ~ handleSave ~ res.data:", res.data)
        setLibelleModeleRapport("");
        setTypeRapport({});
        setLoading(false);
        successNotify("Modèle de rapport creé avec succès.");
      } else {
        console.log("status !==1");
        setLoading(false);
        errorNotify("Erreur de création du modèle de rapport.");
      }
    } catch (error) {
      setLoading(false);
      console.log("🚀 ~ file: catch ~ error", error);
      errorNotify("Erreur de création du modèle de rapport.");
    }
  };

  const handleEditItem = async () => {
    try {
      setLoading(true);
      const apiPayload = {
        libelleModeleRapport,
        idModeleRapport: objetModele.idModeleRapport,
        planModeleRapport: objetModele.planModeleRapport,
      };
      const res: any = await apiClient.post(
        ADMIN_SERVER_BASE_URL,
        "/tablesystem/modifiermodelerapport",
        apiPayload
      );
      console.log(
        "🚀 ~ file: AddModele.tsx ~ line 76 ~ handleEditItem ~ res",
        res
      );
      if (res.status === 1) {
        // const parsedData = {
        //   ...res.data,
        //   planModeleRapport: JSON.parse(res.data.planModeleRapport)
        // };
        dispatch(updateModeleRapport(res.data));
        setLibelleModeleRapport("");
        setRenderModeleEditable(false);
        setLoading(false);
      } else {
        console.log("status !==1");
        setLoading(false);
      }
    } catch (error) {
      console.log("🚀 ~ file: handleSave ~ error", error);
      setLoading(false);
    }
  };

  return (
    <div style={{ marginBottom: 10, backgroundColor: "#ECF0F3", padding: 20 }}>
      <Grid
        container
        spacing={2}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid item md={6} xs={12} sm={6}>
          <TextField
            fullWidth
            name="libelleModele"
            label="libellé"
            value={libelleModeleRapport}
            onChange={(e: any) => setLibelleModeleRapport(e.target.value)}
          />
        </Grid>

        <Grid item md={12} xs={12} sm={12}>
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
          >
            <LoadingButton
              loadingPosition="end"
              loading={loading}
              endIcon={<SaveIcon />}
              size="small"
              variant="contained"
              onClick={!renderModeleEditable ? handleSave : handleEditItem}
            >
              {!renderModeleEditable ? "Enregistrer" : "Modifier"}
            </LoadingButton>

            {/* <Button
              size="small"
              variant="contained"
              onClick={!renderModeleEditable ? handleSave : handleEditItem}
            >
              {!renderModeleEditable ? "Enregistrer" : "Modifier"}
            </Button> */}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
